;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Components/ButtonMenuItem',["jquery", "eventManager", 'loglevel'], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager")) :
    console && console.error('ButtonMenuItem does not support non-amd script loading.');
}(this/* window */, function ($, eventManager, log) {

    function ButtonMenuItem(scope, clickMessagesTransmitting) {
        var self = this;
        Object.defineProperty(this, "scope", { enumerable: true, value: scope });
        Object.defineProperty(this, "$scope", { enumerable: true, value: $(scope) });
        Object.defineProperty(this, 'clickMessagesTransmitting', { enumerable: true, value: clickMessagesTransmitting });

        //#region click messages transmitting registration
        if (clickMessagesTransmitting.length) {
            this.$scope.on("click", "a", function (e) {
                e.preventDefault();

                clickMessagesTransmitting.forEach(function (eventName) {
                    log.debug("ButtonMenuItem raises message: \'%s\'", eventName);

                    eventManager.trigger(eventName, self);
                });

                return !1;
            }).on('keyup', 'a', function (e) {
                // catch enter key only
                if (e.keyCode === 13) {
                    e.preventDefault();
                    clickMessagesTransmitting.forEach(function (eventName) {
                        log.debug("ButtonMenuItem raises message: \'%s\'", eventName);

                        eventManager.trigger(eventName, self);
                    });

                    return !1;
                }
            });
        }
        //#endregion

        this.$scope.on('focus', 'a', this._onFocusHandler.bind(this));
        this.$scope.on('blur', 'a', this._onBlurHandler.bind(this));
    }

    ButtonMenuItem.prototype._onFocusHandler = function (e) {
        $(this).trigger('focus', [this, e]);
    }

    ButtonMenuItem.prototype._onBlurHandler = function (e) {
        $(this).trigger('blur', [this, e]);
    }

    ButtonMenuItem.init = function init(args) {
        if (args.IsEditorEditing) return null;

        var buttonMenuItem = new ButtonMenuItem(args.scope, args.ClickMessagesTransmitting || []);

        return buttonMenuItem;
    };

    return ButtonMenuItem;
}));
